import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
const SERVICE_CATEGORIES = [{
  name: 'Accessories',
  description: 'Curated selection of decorative accessories, artwork, and finishing touches that bring personality and polish to any space.',
  link: '/23m8/accessories.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/Accessories2.JPG&opt=w3'
}, {
  name: 'Apparel',
  description: 'Boutique clothing and jewelry collection featuring timeless pieces that complement your personal style.',
  link: '/23m8/apparel.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/apparel.JPG&opt=w3'
}, {
  name: 'Bathrooms',
  description: 'Complete bathroom design from layout planning to fixture selection, creating spa-like retreats in your home.',
  link: '/23m8/bathrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bathrooms/Bathroom5.jpg&opt=w3'
}, {
  name: 'Bedrooms',
  description: "Restful bedroom designs that balance comfort and style, from master suites to guest rooms and children's spaces.",
  link: '/23m8/bedrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/Bedrooms1.JPG&opt=w3'
}, {
  name: 'Before & After',
  description: 'Transformative design projects that showcase the power of thoughtful planning and expert execution.',
  link: '/23m8/before-after.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Before%20%26%20After/140508121027.jpg&opt=w3'
}, {
  name: 'Commercial',
  description: 'Professional interior design for offices, retail spaces, and hospitality venues that enhance your brand and customer experience.',
  link: '/23m8/commercial.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013937.jpg&opt=w3'
}, {
  name: 'Dining Rooms',
  description: 'Elegant dining spaces designed for both everyday meals and special occasions, with attention to flow and functionality.',
  link: '/23m8/dining-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014171.jpg&opt=w3'
}, {
  name: 'Furniture',
  description: 'Quality furniture selection and custom pieces that anchor your rooms with style and substance.',
  link: '/23m8/furniture.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/IMG_9817.JPG&opt=w3'
}, {
  name: 'Kitchens',
  description: 'Kitchen design that balances beauty and function, from layout optimization to material selection and styling.',
  link: '/23m8/kitchens.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014168.jpg&opt=w3'
}, {
  name: 'Lighting',
  description: 'Lighting design and fixture selection that sets the mood, highlights architecture, and enhances daily living.',
  link: '/23m8/lighting.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lighting%20and%20bathroom.jpg&opt=w3'
}, {
  name: 'Living Rooms',
  description: 'Inviting living spaces designed for how you actually live, with comfortable seating arrangements and thoughtful layouts.',
  link: '/23m8/living-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014111.jpg&opt=w3'
}, {
  name: 'Lower Levels',
  description: 'Basement and lower level transformations that maximize square footage with family rooms, home theaters, and recreation spaces.',
  link: '/23m8/lower-levels.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lower%20level.jpg&opt=w3'
}, {
  name: 'Seminars and Events',
  description: 'Educational workshops and design events where we share our expertise and connect with the community.',
  link: '/23m8/seminars-and-events.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/IMG_3233.jpg&opt=w3'
}, {
  name: 'Staging',
  description: 'Professional real estate staging that helps homes sell faster and for more by showcasing their best features.',
  link: '/23m8/staging.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Blog%20Images/clutter%20free.jpg&opt=w3'
}, {
  name: 'Window Treatments',
  description: 'Custom drapery, blinds, and shades designed to enhance your windows while providing privacy and light control.',
  link: '/23m8/window-treatments.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013895.jpg&opt=w3'
}];
export function Services() {
  return <Layout data-id="element-408">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-409">
        <div className="max-w-4xl mx-auto text-center" data-id="element-410">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-411">
            What We Do
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-412">
            Design Focus Areas &<br data-id="element-413" />
            <span className="italic" data-id="element-414">Expertise</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-415">
            Our services span the full spectrum of interior design, retail
            offerings, and professional staging.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-416">
        <div className="max-w-4xl mx-auto text-center" data-id="element-417">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-418">
            Comprehensive Design Solutions
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-419">
            Each category below represents an area of expertise where we've
            completed hundreds of projects over the past 20 years. Whether you
            need full-service design, retail products, or professional staging,
            we bring the same level of care and attention to every engagement.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-420">
            Browse our focus areas to understand the scope of what we offer,
            then explore our portfolio to see real examples of our work.
          </p>
        </div>
      </section>

      {/* Service Categories Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-421">
        <div className="max-w-7xl mx-auto" data-id="element-422">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-423">
            {SERVICE_CATEGORIES.map(service => <div key={service.name} className="bg-white border border-taupe-200 overflow-hidden hover:shadow-soft transition-shadow duration-300" data-id="element-424">
                {/* Service Image */}
                <a href={service.link} className="block" data-id="element-425">
                  <img src={service.image} alt={service.name} className="aspect-[4/3] w-full object-cover border-b border-taupe-200" data-id="element-426" />
                </a>

                <div className="p-6" data-id="element-427">
                  <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-428">
                    {service.name}
                  </h3>
                  <p className="text-charcoal-900/70 leading-relaxed text-sm mb-4" data-id="element-429">
                    {service.description}
                  </p>
                  <a href={service.link} data-id="element-430">
                    <Button variant="ghost" size="sm" className="text-xs" data-id="element-431">
                      View Examples →
                    </Button>
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 px-4 bg-white" data-id="element-432">
        <div className="max-w-5xl mx-auto" data-id="element-433">
          <div className="text-center mb-16" data-id="element-434">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-435">
              Our Design Process
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-436">
              How we bring your vision to life
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-437">
            {[{
            step: '01',
            title: 'Consultation',
            description: 'We start by listening. Understanding your lifestyle, preferences, and goals is essential to creating spaces that work for you.'
          }, {
            step: '02',
            title: 'Design Development',
            description: 'We create detailed plans, select materials and furnishings, and present options that align with your vision and budget.'
          }, {
            step: '03',
            title: 'Sourcing & Ordering',
            description: 'Leveraging our extensive vendor relationships, we source quality products and manage all ordering, tracking, and coordination.'
          }, {
            step: '04',
            title: 'Installation',
            description: 'We oversee delivery, placement, and styling to ensure every detail is perfect. Your satisfaction is our priority.'
          }].map(phase => <div key={phase.step} className="text-center" data-id="element-438">
                <div className="text-4xl font-serif text-sage-500 mb-4" data-id="element-439">
                  {phase.step}
                </div>
                <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-440">
                  {phase.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed text-sm" data-id="element-441">
                  {phase.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-442">
        <div className="max-w-5xl mx-auto" data-id="element-443">
          <div className="text-center mb-16" data-id="element-444">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-445">
              The Down Home Difference
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-446">
            {['Personalized service from an experienced owner-operator', 'Over 20 years of proven design expertise', 'Full-service approach from concept to installation', 'Local showroom with curated retail offerings', 'Extensive network of trusted contractors and craftspeople', 'Timeless design philosophy that ages gracefully', 'Transparent pricing and clear communication', 'Commitment to your satisfaction and long-term happiness'].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-447">
                <div className="flex-shrink-0 w-6 h-6 bg-sage-500 rounded-full flex items-center justify-center mt-1" data-id="element-448">
                  <Check className="text-white" size={14} data-id="element-449" />
                </div>
                <p className="text-lg text-charcoal-900/80" data-id="element-450">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-451">
        <div className="max-w-4xl mx-auto text-center" data-id="element-452">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-453">
            Let's Discuss Your Project
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-454">
            Whether you're planning a complete renovation or looking for design
            guidance, we're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-455">
            <Link to="/portfolio" data-id="element-456">
              <Button size="lg" className="min-w-[200px]" data-id="element-457">
                View Our Portfolio
              </Button>
            </Link>
            <Link to="/contact" data-id="element-458">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-459">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}